module.exports = __webpack_public_path__ + "static/cfs-logo-444234eaf8a6a35ce139aadf99f4d7e2.png";